import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output
} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
	selector: 'app-valid-input',
	templateUrl: './valid-input.component.html',
	styleUrls: ['./valid-input.component.scss']
})
export class ValidInputComponent implements OnInit {
	constructor() {}

	@Input() placeHolder: string;
	@Input() inputType = 'text';
	@Input() control: FormControl;
	@Input() model: string;

	inputTypeUsed = 'text';
	errorPattern: string;

	togglePassword = false;

	ngOnInit(): void {
		this.inputTypeUsed = this.inputType;
		if (this.inputType === 'password') {
			this.errorPattern =
				'Au moins 1 minuscule, 1 majuscule et 1 chiffre sont requis.';
		} else if (this.inputType === 'email') {
			this.errorPattern = `L'email saisi est incorrect.`;
		}
	}

	showError() {
		if (this.control) {
			const { touched, dirty, errors } = this.control;
			return touched && dirty && errors;
		}
	}

	togglePasswordToText() {
		this.togglePassword = !this.togglePassword;
		this.inputTypeUsed = this.togglePassword ? 'text' : 'password';
	}
}
